<template>
  <div class="redirect-control-container">
    <el-card class="container-card" shadow="hover">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm" label-position="right" label-width="80px" class="search-form"
               style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px; overflow-x: auto;">

        <el-form-item label="用户" size="small" style="display: flex;align-items: center;">
          <el-input v-model="searchForm.userId" placeholder="请输入用户" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="用户标识" size="small" style="display: flex;align-items: center;">
          <el-input v-model="searchForm.userUuid" placeholder="请输入用户标识" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="状态" size="small" style="display: flex;align-items: center;">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 120px;">
            <el-option label="未启用" value="0"></el-option>
            <el-option label="已启用" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch" plain>搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" icon="el-icon-refresh" @click="resetSearch" plain>重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" size="small" @click="batchDelete" :disabled="selection.length === 0">
            批量删除({{selection.length}})
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        class="data-table"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" min-width="55" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户" min-width="120" align="center"></el-table-column>
        <el-table-column prop="userUuid" label="用户标识" min-width="200" align="center"></el-table-column>
        <el-table-column
          prop="link"
          label="跳转链接"
          min-width="300"
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column prop="count" label="已使用次数" min-width="120" align="center"></el-table-column>
        <el-table-column prop="totalCount" label="总次数" min-width="120" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'danger' : 'success'">
              {{ scope.row.status === 0 ? '未启用' : '已启用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)" plain>编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" plain>删除</el-button>
            <el-button size="mini" type="success" plain @click="copyLink(scope.row)">复制链接</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background small>
        </el-pagination>
      </div>

      <!-- 新增/编辑对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="handleDialogClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="用户" prop="userId">
            <el-input v-model="form.userId" placeholder="请输入用户" :disabled="isEditMode"></el-input>
          </el-form-item>

          <el-form-item label="用户标识" prop="userUuid">
            <el-input v-model="form.userUuid" placeholder="请输入用户标识" :disabled="isEditMode"></el-input>
          </el-form-item>

          <el-form-item label="跳转链接" prop="link">
            <el-input v-model="form.link" placeholder="请输入跳转链接" type="textarea" :rows="3" spellcheck="false"></el-input>
          </el-form-item>

          <el-form-item label="总次数" prop="totalCount">
            <el-input-number v-model="form.totalCount" :min="0" controls-position="right"></el-input-number>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="0">未启用</el-radio>
              <el-radio :label="1">已启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '../../until/controlRequest'

export default {
  name: 'RedirectControl',
  data() {
    return {
      searchForm: {
        userId: '',
        userUuid: '',
        status: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增跳转链接',
      form: {
        id: null,
        userId: '',
        userUuid: '',
        link: '',
        totalCount: 0,
        status: 0
      },
      rules: {
        userId: [
          { required: true, message: '请输入用户', trigger: 'blur' }
        ],
        userUuid: [
          { required: true, message: '请输入用户标识', trigger: 'blur' }
        ],
        link: [
          { required: true, message: '请至少添加一个跳转链接', trigger: 'blur' }
        ],
        totalCount: [
          { required: true, message: '请输入总次数', trigger: 'blur' }
        ]
      },
      isEditMode: false,
      selection: []
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {
    // 获取分页数据
    fetchPage() {
      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        userId: this.searchForm.userId,
        userUuid: this.searchForm.userUuid,
        status: this.searchForm.status
      }
      get('/v1/redirect/page', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.fetchPage()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        userId: '',
        userUuid: '',
        status: ''
      }
      this.handleSearch()
    },

    // 处理分页大小改变
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },

    // 处理当前页改变
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchPage()
    },

    // 处理选择变化
    handleSelectionChange(val) {
      this.selection = val
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增跳转链接'
      this.form = {
        id: null,
        userId: '',
        userUuid: '',
        link: '',
        totalCount: 0,
        status: 0
      }
      this.isEditMode = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑跳转链接'
      this.form = {
        id: row.id,
        userId: row.userId,
        userUuid: row.userUuid,
        link: row.link,
        totalCount: row.totalCount,
        status: row.status
      }
      this.isEditMode = true
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const requestData = {
          ...this.form
        }

        if (this.isEditMode) {
          // 编辑模式 - 更新单条记录
          post('/v1/redirect/update', requestData)
            .then(() => {
              this.$message.success('更新成功')
              this.dialogVisible = false
              this.fetchPage()
            })
            .catch(() => {
              this.$message.error('更新失败')
            })
        } else {
          // 新增模式 - 批量插入
          const insertData = {
            userId: this.form.userId,
            userUuid: this.form.userUuid,
            link: this.form.link.split('\n').filter(item => item.trim()), // 后端接口要求是数组
            totalCount: this.form.totalCount,
            status: this.form.status
          }

          post('/v1/redirect/insert', insertData)
            .then(() => {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.fetchPage()
            })
            .catch(() => {
              this.$message.error('新增失败')
            })
        }
      })
    },

    // 删除单条记录
    handleDelete(row) {
      this.$confirm(`确定要删除客户标识为 "${row.userUuid}" 的跳转链接吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/v1/redirect/delete?id=${row.id}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 批量删除
    batchDelete() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }

      const ids = this.selection.map(item => item.id)
      console.log(this.selection)
      console.log(ids)
      this.$confirm(`确定要删除选中的 ${ids.length} 条记录吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post('/v1/redirect/batchDelete', ids)
          .then(() => {
            this.$message.success('批量删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('批量删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 关闭对话框
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },

    // 复制链接到剪贴板
    copyLink(row) {
      const url = `https://control.zjwec.cn/api/v1/redirect?kehu=${row.userUuid}`
      // const url = `http://127.0.0.1:9998/api/v1/redirect?kehu=${row.userUuid}`
      navigator.clipboard.writeText(url).then(() => {
        this.$message.success('链接复制成功')
      }).catch(err => {
        this.$message.error('复制失败，请手动复制')
        console.error('复制失败:', err)
      })
    }
  }
}
</script>

<style scoped>
.redirect-control-container {
  padding: 20px;
}

.container-card {
  min-height: calc(100vh - 90px);
}

.search-form {
  margin-bottom: 20px;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}

.el-button--warning {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/redirect/RedirectControl.vue